(function () {
  'use strict';

  var frames       = [];   // HTMLImageElement[] (indexed by sorted position)
  var total        = 0;
  var currentFrame = 0;
  var canvas, ctx;
  var overlayEl, spinnerEl, containerEl;
  var dragging     = false;
  var pointerDown  = false; // true while button/finger is held (prevents rotation on hover)
  var lastX        = 0;
  var startX       = 0;  // touch start X (for direction detection)
  var startY       = 0;  // touch start Y (for direction detection)
  var captured     = false; // whether setPointerCapture has been called
  var cumulativeDeg = 0;   // cumulative drag distance in "degrees" (1 px = 1°)
  var rafId        = null;
  var ready        = false;
  var imgW = 0, imgH = 0;
  var isMobile     = window.matchMedia('(max-width: 767px)').matches;
  var direction    = 1;   // 1 = default, -1 = invertito
  var hintEl       = null;
  var hintTimer    = null;
  var galleryViewerOpen = false;
  var toggleBtnEl  = null;
  var closeBtnEl   = null;

  // ── URL sort (numeric filename suffix) ────────────────────────────────────
  function sortUrls(urls) {
    return urls.slice().sort(function (a, b) {
      function num(u) {
        var f = u.split('/').pop().split('?')[0];
        var m = f.match(/(\d+)(?=\.[a-z]+$)/);
        return m ? parseInt(m[1], 10) : 0;
      }
      return num(a) - num(b);
    });
  }

  // ── Append Shopify CDN width param on mobile to reduce download size ───────
  function mobileUrl(url) {
    if (!isMobile) return url;
    if (url.indexOf('cdn.shopify.com') === -1) return url;
    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=600';
  }

  // ── On-demand render (RAF only when something changed) ────────────────────
  function scheduleRender() {
    if (rafId || !ready) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      var frame = frames[currentFrame];
      if (frame) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(frame, 0, 0, canvas.width, canvas.height);
      }
    });
  }

  // ── Resize: fit canvas inside container, centre with CSS ──────────────────
  function resize() {
    if (!containerEl || !imgW || !imgH) return;
    var cw = containerEl.clientWidth;
    var ch = containerEl.clientHeight;
    if (!cw || !ch) return;
    var scale = Math.min(cw / imgW, ch / imgH);
    var w = Math.round(imgW * scale);
    var h = Math.round(imgH * scale);
    canvas.width  = w;
    canvas.height = h;
    canvas.style.left = Math.round((cw - w) / 2) + 'px';
    canvas.style.top  = Math.round((ch - h) / 2) + 'px';
    scheduleRender();
  }

  // ── Called when the first image is ready ──────────────────────────────────
  function showViewer() {
    if (spinnerEl) spinnerEl.style.display = 'none';
    ready = true;
    resize();
    if (window.product360GalleryMode) {
      // In gallery mode: only show canvas if the viewer is already open (e.g. variant change)
      if (galleryViewerOpen) canvas.style.display = 'block';
    } else {
      canvas.style.display = 'block';
      showHint();
    }
  }

  // ── 360 hint badge ────────────────────────────────────────────────────────
  function showHint() {
    if (!hintEl) return;
    hintEl.style.opacity = '1';
  }

  function hideHint() {
    if (!hintEl) return;
    hintEl.style.opacity = '0';
  }

  function scheduleShowHint() {
    clearTimeout(hintTimer);
    hintTimer = setTimeout(showHint, 5000);
  }

  // ── Parallel image loading ─────────────────────────────────────────────────
  function loadImages(urls) {
    // On mobile use every other frame: halves HTTP requests and memory usage
    var step = isMobile ? 2 : 1;
    var loadUrls = [];
    for (var fi = 0; fi < urls.length; fi += step) {
      loadUrls.push(mobileUrl(urls[fi]));
    }

    total  = loadUrls.length;
    frames = new Array(total);
    var initDone = false;

    loadUrls.forEach(function (url, i) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        frames[i] = img;
        if (!initDone) {
          imgW = img.naturalWidth;
          imgH = img.naturalHeight;
          // Fill empty slots with this first image so the viewer can start immediately
          for (var k = 0; k < total; k++) {
            if (!frames[k]) frames[k] = img;
          }
          initDone = true;
          showViewer();
        }
        // Re-render if this slot is now being displayed
        if (i === currentFrame) scheduleRender();
      };
      img.src = url;
    });
  }
 
  // ── Frame selection from drag delta ───────────────────────────────────────
  function updateFrame(dx) {
    cumulativeDeg += dx * direction; // 1 px = 1° — direction: 1 default, -1 invertito
    var frame = Math.round((cumulativeDeg / 360) * total);
    frame = ((frame % total) + total) % total;
    if (frame !== currentFrame) {
      currentFrame = frame;
      scheduleRender();
    }
  }

  // ── Pointer events (handles mouse + touch via Pointer Events API) ──────────
  function onPointerDown(e) {
    if (!e.isPrimary) return;
    pointerDown = true;
    dragging  = false;   // confirmed only after direction check
    captured  = false;
    lastX     = e.clientX;
    startX    = e.clientX;
    startY    = e.clientY;
    canvas.style.cursor = 'grabbing';
    hideHint();
  }

  function onPointerMove(e) {
    if (!e.isPrimary || !pointerDown) return; // ignore hover (no button held)
    // Direction-detection phase: wait until the finger moves enough
    if (!captured) {
      var totalDx = Math.abs(e.clientX - startX);
      var totalDy = Math.abs(e.clientY - startY);
      if (totalDx < 5 && totalDy < 5) return; // too small to decide
      if (totalDy > totalDx) return;           // vertical scroll intent — let browser handle it
      // Horizontal drag confirmed: lock pointer
      canvas.setPointerCapture(e.pointerId);
      captured = true;
      dragging = true;
    }
    if (!dragging) return;
    var dx = e.clientX - lastX;
    lastX  = e.clientX;
    updateFrame(dx);
    scheduleShowHint();
  }

  function onPointerUp(e) {
    if (!e.isPrimary) return;
    pointerDown = false;
    dragging = false;
    captured = false;
    if (canvas.hasPointerCapture(e.pointerId)) canvas.releasePointerCapture(e.pointerId);
    canvas.style.cursor = 'grab';
  }

  // ── Get images data for a given variant ID ────────────────────────────────
  function getImagesForVariant(variantId) {
    var map = window.product360VariantImages;
    if (map && Object.keys(map).length > 0) {
      if (variantId && map[variantId]) return map[variantId];
      return null;
    }
    if (window.product360FallbackImages) return window.product360FallbackImages;
    return null;
  }

  // ── Gallery mode: open / close the 3D viewer ─────────────────────────────
  function openGalleryViewer() {
    galleryViewerOpen = true;
    overlayEl.style.display = '';
    overlayEl.style.pointerEvents = 'auto';   // block slider interactions
    overlayEl.style.background = '#ffffff';       // ensure gallery is covered
    if (ready) canvas.style.display = 'block';
    if (spinnerEl) spinnerEl.style.display = ready ? 'none' : '';
    if (toggleBtnEl) toggleBtnEl.style.display = 'none';
    if (closeBtnEl)  closeBtnEl.style.display  = 'flex';
    var galleryEl = containerEl && containerEl.closest('media-gallery');
    var thumbsEl  = galleryEl && galleryEl.querySelector('.product__thumbnails');
    if (thumbsEl) thumbsEl.style.display = 'none';
    resize();
  }

  function closeGalleryViewer() {
    galleryViewerOpen = false;
    canvas.style.display = 'none';
    overlayEl.style.display = 'none';
    overlayEl.style.pointerEvents = '';
    overlayEl.style.background = '';
    if (toggleBtnEl) toggleBtnEl.style.display = 'flex';
    if (closeBtnEl)  closeBtnEl.style.display  = 'none';
    var galleryEl = containerEl && containerEl.closest('media-gallery');
    var thumbsEl  = galleryEl && galleryEl.querySelector('.product__thumbnails');
    if (thumbsEl) thumbsEl.style.display = '';
  }

  // ── Load a new set of 360 images, resetting viewer state ──────────────────
  function loadVariant(data) {
    // Supporto fileMask + count (es. "Revotech_{n}.webp" + 64)
    if (data && data.fileMask && data.count) {
      data.images = [];
      for (var fi = 1; fi <= data.count; fi++) {
        data.images.push(data.fileMask.replace('{n}', fi));
      }
    }
    if (!data || !data.images || !data.images.length) {
      if (overlayEl) overlayEl.style.display = 'none';
      if (canvas) canvas.style.display = 'none';
      if (window.product360GalleryMode) {
        galleryViewerOpen = false;
        if (toggleBtnEl) toggleBtnEl.style.display = 'none';
        if (closeBtnEl) closeBtnEl.style.display = 'none';
        var galEl = containerEl && containerEl.closest('media-gallery');
        var thbEl = galEl && galEl.querySelector('.product__thumbnails');
        if (thbEl) thbEl.style.display = '';
      }
      return;
    }
    direction = data.direction || 1;
    ready = false;
    frames = [];
    currentFrame = 0;
    cumulativeDeg = 0;
    hideHint();
    clearTimeout(hintTimer);
    if (window.product360GalleryMode) {
      // In gallery mode: reload silently; if viewer is open show spinner
      if (galleryViewerOpen) {
        canvas.style.display = 'none';
        if (spinnerEl) spinnerEl.style.display = '';
      } else {
        if (toggleBtnEl) toggleBtnEl.style.display = 'flex';
      }
    } else {
      overlayEl.style.display = '';
      if (canvas) canvas.style.display = 'none';
      if (spinnerEl) spinnerEl.style.display = '';
    }
    loadImages(sortUrls(data.images.map(function (f) { return data.baseURL + f; })));
  }

  // ── Bootstrap ─────────────────────────────────────────────────────────────
  function init() {
    overlayEl  = document.getElementById('product-360-overlay');
    spinnerEl  = overlayEl && overlayEl.querySelector('.viewer-360-loading');
    if (!overlayEl) return;

    var initialData = getImagesForVariant(window.product360CurrentVariantId);
    if (!initialData) return;

    containerEl = overlayEl.parentElement;


    // In gallery mode the overlay is inside <media-gallery>; start it hidden
    if (window.product360GalleryMode) {
      overlayEl.style.display = 'none';
    } else {
      // Always-on 3D mode: permanently hide thumbnails
    var galleryRootEl = containerEl && containerEl.closest('media-gallery');
    var thumbsEl      = galleryRootEl && galleryRootEl.querySelector('.product__thumbnails');
    if (thumbsEl) thumbsEl.style.display = 'none';

    }


    canvas = document.createElement('canvas');
    canvas.style.cssText = 'position:absolute;display:none;cursor:grab;touch-action:pan-y;';
    overlayEl.appendChild(canvas);
    ctx = canvas.getContext('2d');

    // 360 hint badge (only 3D mode)
    if (!window.product360GalleryMode) {
      hintEl = document.createElement('div');
      hintEl.className = 'viewer-360-hint';
      hintEl.innerHTML =
      '<svg id="product_3d_view" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="white">'
      + '<path d="M21.2,44.9v-6.39S2.17,42.72,2.17,52.55s20.83,15.54,35.46,16.74c.66.05,1.19.55,1.29,1.2l.1,1.85,25.38-6.24-25.72-6.65.04,2.02c.03.88-.74.58-1.61.46-4.06-.58-15.22-2.44-18.89-6.39-4.61-4.96-.65-8.6,2.98-10.64Z"/>'
      + '<path d="M79.1,38.7s18.81,3.25,18.81,13.24-20.24,17.86-41.21,17.86l12.23-3.96-12.22-2.94s16.16-2.15,24.51-6.65c11.61-6.25-2.12-11.65-2.12-11.65v-5.9Z"/>'
      + '<path d="M21.78,37.36c.3-2.66,2-6.08,8.05-6.08,5.22,0,7.67,2.7,7.67,5.8,0,2.44-1.44,3.63-2.76,4.19v.11c1.31.48,3.52,1.69,3.52,4.93s-2.23,6.68-8.47,6.68c-6.62,0-8.22-3.88-8.39-6.35h5.76c.19,1.19.85,2.24,2.54,2.24,1.56,0,2.32-1.06,2.32-2.65,0-1.72-.74-2.67-2.93-2.67h-1.85v-4.1h1.75c1.93,0,2.51-.62,2.51-2.06,0-1.2-.6-1.99-1.96-1.99-1.6,0-2.02.91-2.17,1.94h-5.57Z"/>'
      + '<path d="M51.56,36.98c-.17-.83-.57-1.72-2.06-1.72-2.06,0-2.66,1.92-2.76,4.52.91-.88,2.3-1.51,4.41-1.51,3.77,0,6.62,2.62,6.62,6.9,0,4.71-3.23,7.84-8.4,7.84-6.39,0-8.77-4.48-8.77-10.59,0-5.56,2.12-11.13,9.01-11.13,5.48,0,7.43,3.29,7.59,5.69h-5.64ZM51.6,45.64c0-1.84-.46-3.26-2.39-3.26-1.57,0-2.32,1.04-2.32,3.08,0,1.76.57,3.42,2.35,3.42,1.63,0,2.37-1.3,2.37-3.24Z"/>'
      + '  <path d="M77.67,42.03c0,5.96-2.15,10.97-8.76,10.97s-8.73-4.97-8.73-10.84,2.29-10.87,8.81-10.87,8.68,4.65,8.68,10.74ZM66.49,42.07c0,4.37.35,6.63,2.48,6.63s2.37-2.21,2.37-6.62-.37-6.49-2.35-6.49-2.5,1.72-2.5,6.48Z"/>'
      + '<path d="M86.34,30.95c0,2.97-2.12,4.72-4.92,4.72s-4.76-1.91-4.76-4.6,1.92-4.68,4.82-4.68c3.13,0,4.85,2.05,4.85,4.56ZM79.49,31.04c0,1.27.71,2.27,1.97,2.27s1.99-1,1.99-2.28-.63-2.32-1.99-2.32-1.97,1.02-1.97,2.33Z"/>'
      + '</svg>';
      overlayEl.appendChild(hintEl);
    }

    // Gallery mode: toggle button (top-right of gallery) + close button (inside overlay)
    if (window.product360GalleryMode) {
      var toggleSvg = '<svg id="product_3d_view" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="currentColor">'
        + '<path d="M21.2,44.9v-6.39S2.17,42.72,2.17,52.55s20.83,15.54,35.46,16.74c.66.05,1.19.55,1.29,1.2l.1,1.85,25.38-6.24-25.72-6.65.04,2.02c.03.88-.74.58-1.61.46-4.06-.58-15.22-2.44-18.89-6.39-4.61-4.96-.65-8.6,2.98-10.64Z"/>'
        + '<path d="M79.1,38.7s18.81,3.25,18.81,13.24-20.24,17.86-41.21,17.86l12.23-3.96-12.22-2.94s16.16-2.15,24.51-6.65c11.61-6.25-2.12-11.65-2.12-11.65v-5.9Z"/>'
        + '<path d="M21.78,37.36c.3-2.66,2-6.08,8.05-6.08,5.22,0,7.67,2.7,7.67,5.8,0,2.44-1.44,3.63-2.76,4.19v.11c1.31.48,3.52,1.69,3.52,4.93s-2.23,6.68-8.47,6.68c-6.62,0-8.22-3.88-8.39-6.35h5.76c.19,1.19.85,2.24,2.54,2.24,1.56,0,2.32-1.06,2.32-2.65,0-1.72-.74-2.67-2.93-2.67h-1.85v-4.1h1.75c1.93,0,2.51-.62,2.51-2.06,0-1.2-.6-1.99-1.96-1.99-1.6,0-2.02.91-2.17,1.94h-5.57Z"/>'
        + '<path d="M51.56,36.98c-.17-.83-.57-1.72-2.06-1.72-2.06,0-2.66,1.92-2.76,4.52.91-.88,2.3-1.51,4.41-1.51,3.77,0,6.62,2.62,6.62,6.9,0,4.71-3.23,7.84-8.4,7.84-6.39,0-8.77-4.48-8.77-10.59,0-5.56,2.12-11.13,9.01-11.13,5.48,0,7.43,3.29,7.59,5.69h-5.64ZM51.6,45.64c0-1.84-.46-3.26-2.39-3.26-1.57,0-2.32,1.04-2.32,3.08,0,1.76.57,3.42,2.35,3.42,1.63,0,2.37-1.3,2.37-3.24Z"/>'
        + '  <path d="M77.67,42.03c0,5.96-2.15,10.97-8.76,10.97s-8.73-4.97-8.73-10.84,2.29-10.87,8.81-10.87,8.68,4.65,8.68,10.74ZM66.49,42.07c0,4.37.35,6.63,2.48,6.63s2.37-2.21,2.37-6.62-.37-6.49-2.35-6.49-2.5,1.72-2.5,6.48Z"/>'
        + '<path d="M86.34,30.95c0,2.97-2.12,4.72-4.92,4.72s-4.76-1.91-4.76-4.6,1.92-4.68,4.82-4.68c3.13,0,4.85,2.05,4.85,4.56ZM79.49,31.04c0,1.27.71,2.27,1.97,2.27s1.99-1,1.99-2.28-.63-2.32-1.99-2.32-1.97,1.02-1.97,2.33Z"/>'
        + '</svg>';


      toggleBtnEl = document.createElement('button');
      toggleBtnEl.type = 'button';
      toggleBtnEl.className = 'viewer-360-toggle-btn';
      toggleBtnEl.setAttribute('aria-label', 'Visualizzazione 360°');
      toggleBtnEl.innerHTML = toggleSvg;
      containerEl.appendChild(toggleBtnEl);
      toggleBtnEl.addEventListener('click', openGalleryViewer);

      closeBtnEl = document.createElement('button');
      closeBtnEl.type = 'button';
      closeBtnEl.className = 'viewer-360-close-btn';
      closeBtnEl.setAttribute('aria-label', 'Chiudi visualizzazione 360°');
      closeBtnEl.innerHTML = '&times;';
      closeBtnEl.style.display = 'none';
      overlayEl.appendChild(closeBtnEl);
      closeBtnEl.addEventListener('click', closeGalleryViewer);
    }
    canvas.addEventListener('pointerdown',   onPointerDown);
    canvas.addEventListener('pointermove',   onPointerMove);
    canvas.addEventListener('pointerup',     onPointerUp);
    canvas.addEventListener('pointercancel', onPointerUp);

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(resize).observe(containerEl);
    } else {
      window.addEventListener('resize', resize);
    }

    // Swap 3D model when the customer selects a different variant.
    // theme.pubsub fires on EVERY variant change (the CustomEvent 'variant:change'
    // is dispatched on the product <form> with bubbles:false so never reaches document).
    function onVariantChange(event) {
      var variant = (event.data && event.data.variant) || (event.detail && event.detail.variant);
      if (!variant) return;
      loadVariant(getImagesForVariant(variant.id));
    }
    if (window.theme && window.theme.pubsub && window.theme.pubsub.PUB_SUB_EVENTS) {
      window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.variantChange, onVariantChange);
    } else {
      // Fallback: listen on document (works when productForm is absent)
      document.addEventListener('variant:change', onVariantChange);
    }

    loadVariant(initialData);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
